import mapboxgl from 'mapbox-gl';
import {MapboxSearchBox} from "@mapbox/search-js-web"; // or "const mapboxgl = require('mapbox-gl');"

const filters = Array.from(document.querySelectorAll('button.filter, a.filter'));
const selects = Array.from(document.querySelectorAll('select.filter'));
const allFilters = Array.from(document.getElementsByClassName('filter'));
const filterToggle = document.getElementById('morefilters');
const moreFilters = document.getElementById('toggle');
const moreOrLess = document.getElementById('more-less-filters');
const filtercount = document.getElementById('filtercount');
const accessToken = window.mapboxtoken;
mapboxgl.accessToken = accessToken;

const map = new mapboxgl.Map({
    container: 'map', // container ID
    style: window.mapboxstyle, // style URL
    center: window.locations['Center'], // starting position [lng, lat]
    zoom: window.locations['Zoom'] ?? 5, // starting zoom,
    maxZoom: 16
});
const search = new MapboxSearchBox();
search.accessToken = accessToken;
search.options = {
    language: 'en',
    country: 'NZ',
}

search.theme = {
    variables: {
        boxShadow: 'none',
        colorBackground: '#FFFFFF',
        colorBackdrop: '#EAEAEA',
        fontFamily: '"Montserrat" sans-serif',
        padding: 0,
    },
    cssText: "#searchbox { \
    color: #231F20;\
    }\
    #searchbox input { \
            box-shadow: none !important; \
            background-color: #EAEAEA; \
            border-radius: 4px; \
            opacity: 1; \
            left: 16px; \
            height: 44px;\
        }\
        .Results {\
        padding: 15px;\
        box-shadow: 0px 10px 32px 0px rgba(0,0,0,0.20);\
        }\
        .Results .SuggestionText {\
        padding: 5px 2px;\
        box-shadow: none;\
        }"
}

search.popoverOptions.offset = 1;
search.popoverOptions.flip = true;


const baseUrl = window.location.href;
let url = baseUrl.split('?')[0];
url = url.split('#')[0];

const init = () => {
    map.on('load', (e) => {
        addSource();
        addCluster();
        addClusterCount();
        addPoint();
        bindPopup();
        document.getElementById('mapboxholder').append(search);
        search.bindMap(map);
        initFilters();
        map.addControl(new mapboxgl.NavigationControl());
    });
    if (window.locations['Target']) {
        zoomTo();
    }
}
const addSource = () => {
    map.addSource('votelocations', {
        type: 'geojson',
        data: `${url}/geolocations`,
        cluster: true,
        clusterMaxZoom: 10, // Max zoom to cluster points on
        clusterRadius: 50 // Radius of each cluster when clustering points (defaults to 50)
    });
}
const addCluster = () => {
    map.addLayer({
        id: 'clusters',
        type: 'circle',
        source: 'votelocations',
        filter: ['has', 'point_count'],
        paint: {
            'circle-color': [
                'step',
                ['get', 'point_count'],
                '#f89628',
                250,
                '#f89628',
                1000,
                '#E65B04'
            ],
            'circle-radius': [
                'step',
                ['get', 'point_count'],
                20,
                250,
                30,
                1000,
                40
            ]
        }
    });
}

const addClusterCount = () => {
    map.addLayer({
        id: 'cluster-count',
        type: 'symbol',
        source: 'votelocations',
        filter: ['has', 'point_count'],
        layout: {
            'text-field': ['get', 'point_count_abbreviated'],
            'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
            'text-size': 12
        },
        paint: {
            'text-color': '#000000'
        }
    });
}

const addPoint = () => {
    map.loadImage('/_resources/votelocations/images/mapbox-marker-icon-20px-red.png', (error, image) => {
        if (error) {
            throw error;
        }
        map.addImage('marker', image);
    });
    map.addLayer({
        id: 'unclustered-point',
        type: 'symbol',
        source: 'votelocations',
        filter: ['!', ['has', 'point_count']],
        layout: {
            'icon-image': 'marker',
            'icon-size': 0.5,
            'icon-allow-overlap': true

        }
    });
}

const bindPopup = () => {
    map.on('click', 'unclustered-point', (element) => {
        const coordinates = element.features[0].geometry.coordinates.slice();
        const id = element.features[0].properties['ID'];
        getDescription(id, coordinates, element);
    });
}

const popupHelper = (coordinates, description) => {
    new mapboxgl.Popup()
        .setLngLat(coordinates)
        .setHTML(description)
        .addTo(map);

    let close = document.getElementsByClassName('mapboxgl-popup-close-button')[0];
    let card = document.getElementsByClassName('card')[0];
    close.remove();
    document.getElementsByClassName('mapboxgl-popup-content')[0].insertBefore(close, card);

}

const zoomTo = () => {
    map.on('idle', 'unclustered-point', (elements) => {
        elements.features.forEach((element) => {
            if (element.properties['ID'] === window.locations['Target']) {
                const coordinates = window.locations['Center'];
                const id = element.properties['ID'];
                getDescription(id, coordinates, element);
                window.locations['Target'] = false;
            }
        });
    });
}

const addEvent = (element, method) => {
    element.addEventListener(method, (self) => {
        let target = self.target;
        if (target.nodeName === 'SPAN') {
            target = target.parentElement;
        }
        let filterType = target.getAttribute('data-type');

        if (target.classList.contains('active') && filterType !== 'open-date') {
            filterType = false;
            target.classList.remove('active');
        } else {
            target.classList.add('active');
        }
        if (!target.classList.contains('no-clear')) {
            allFilters.forEach((element) => {
                if (!element.classList.contains('no-clear') && element !== target) {
                    element.classList.remove('active');
                }
                if (target.nodeName !== 'SELECT') {
                    element.value = '';
                }
            });
        }
        let dataSrc = `${url}/geolocations`
        let filters = {'filter': []};
        let urlfilters = false;

        if (filterType !== 'reset') {
            allFilters.forEach((element) => {
                if (element.classList.contains('active')) {
                    if (element.getAttribute('data-type') === 'open-date') {
                        let dateValue = document.getElementById('datefilterdropdown').value;
                        if (dateValue !== '') {
                            filters['date'] = dateValue;
                            filters['filter'].push('open-date');
                        } else {
                            element.classList.remove('active');
                        }
                    }

                    let activeFilter = element.getAttribute('data-type');
                    if (activeFilter !== 'open-date') {
                        filters['filter'].push(activeFilter);
                    }
                }
            });
            filters['filter'] = filters['filter'].filter((value, index, array) => array.indexOf(value) === index);
            urlfilters = new URLSearchParams(filters);
        } else {
            allFilters.forEach((element) => {
                element.classList.remove('active');
                element.value = '';
            })
        }
        if (filters['filter'].length > 0) {
            filtercount.innerText = filters['filter'].length;
            filtercount.classList.remove('hidden');
        } else {
            filtercount.classList.add('hidden');
        }
        map.getSource('votelocations').setData(`${dataSrc}?${urlfilters}`);
    });
}

const getDescription = (id, coordinates, element) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', `${url}/description?id=${id}`, true);
    xhr.onreadystatechange = () => {
        if (xhr.readyState >= 4 && xhr.status === 200) {            // Parse outfitList
            // Ensure that if the map is zoomed out such that multiple
            // copies of the feature are visible, the popup appears
            // over the copy being pointed to.
            map.flyTo({'center': [coordinates[0], coordinates[1]], 'zoom': 16});

            popupHelper(coordinates, xhr.responseText);
        }
    }
    xhr.send();

}


const initFilters = () => {
    filters.forEach((element) => addEvent(element, 'click'));
    selects.forEach((element) => addEvent(element, 'change'));
}
export default () => {
    init();
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    // We listen to the resize event
    window.addEventListener('resize', () => {
        // Hack around mobile safari
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
    filterToggle.addEventListener('click', () => {
        moreFilters.classList.toggle('hidden');
        if (moreFilters.classList.contains('hidden')) {
            moreOrLess.innerText = 'More filters';
        } else {
            moreOrLess.innerText = 'Less filters';
        }
    });
}
